<style lang="scss">
$klz-red: #c50c0e;
input[type=text] {   
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
.login-bar {
    transition: all 500ms ease;
    opacity: 1;
    max-height: 230px;

    &.bar-enter,
    &.bar-leave-to {
        opacity: 0;
        max-height: 0;
    }
    [class*="col-"] {
        }
    .login-box-main {
        border-top: 1px solid #ccc;
        padding: 20px 0 30px;
        label {
            display: none;
        }

        button {
            display: block;
            width: 100%;
            padding: 8px;
            border: 2px solid $klz-red;
            color: $klz-red;
            background: none;
            text-transform: uppercase;
            letter-spacing: 1px;
            transition: all 500ms ease;
            &:hover {
                background: $klz-red;
                color: #fff;
            }
            &:active,
            &:focus {
                outline: 0;
            }
            @media(max-width:992px) {
                margin: 10px 0;
                padding: 10px;
            }
            @media(max-width:768px) {
              margin: 0 0 10px 0;
            }
        }
        input {
            border: 1px solid #ccc;
            padding: 10px;
            display: block;
            width: 100%;
            @media(max-width:768px) {
                margin-bottom: 10px;
            }
            &:active,
            &:focus {
                outline: 0;
                border: 1px solid $klz-red;
            }
        }
        a {
            display: block;
            text-align: center;
            font-size: 90%;
            color: #000;
            &:hover {
                text-decoration: none;
                &:hover {
                    color: #666;
                }
            }

        }
    }
}
</style>

<template>
<transition name="bar">
  <b-container class="login-bar" v-if="showLogin">
    <div class="login-box-main">
      <b-row v-if="!lostPassword" class="align-items-center justify-content-center">
        <b-col lg="3" md="6">
          <label>Email Adresse</label>
          <input type="email" name="email" v-model="email" placeholder="E-Mail Adresse" />
        </b-col>
        <b-col lg="3" md="6">
          <label>Passwort</label>
          <input type="password" name="password" v-model="password" placeholder="Passwort" />
        </b-col>
        <b-col lg="3" md="12">
          <button @click="login()">Login</button>
        </b-col>
        <b-col lg="3" md="12">
          <a href="#" @click="toggleLostPassword">Passwort vergessen?</a>
        </b-col>
      </b-row>
      <b-row v-if="lostPassword" class="align-items-center justify-content-center">
        <b-col lg="4" md="6">
          <label>Email Adresse</label>
          <input type="email" name="email" v-model="email"  placeholder="E-Mail Adresse"  />
        </b-col>
        <b-col lg="4" md="12">
          <button @click="reset()">Neues Passwort anfordern</button>
        </b-col>
        <b-col lg="4" md="12">
          <a href="#" @click="toggleLostPassword">Zurück zum Login</a>
        </b-col>
      </b-row>
      <b-row v-if="loginError" class="error">
        <b-col>
          Falsche E-Mail-Adresse oder Passwort!
        </b-col>
      </b-row>
    </div>
  </b-container>
</transition>
</template>



<script type="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'LoginBar',
  data() {
    return {
      email: "",
      password: "",
      lostPassword: false,
      message: false
    }
  },
  methods: {
    login() {
      this.$store.dispatch('login', {
        user: this.email,
        password: this.password
      });
    },
    reset() {
      this.$store.dispatch('resetpassword', this.email)
        .then(function(results) {
          if (results.data.message.success) {
            this.lostPassword = false;
            this.$store.dispatch('addMessage', {
              message: 'Password zurückgesetzt! Bitte prüfen sie ihre Emails.',
              type: 'success'
            });
          } else {
            this.$store.dispatch('addMessage', {
              message: 'Fehler: Bitte versuchen Sie es später erneut',
              type: 'error'
            });
          }
        }.bind(this));
    },
    toggleLostPassword() {
      this.lostPassword = !this.lostPassword;
    }
  },
  computed: {
    showLogin() {
      return this.$store.state.showLogin;
    },
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    loginError() {
      return this.$store.state.loginError;
    }
  }
});
</script>
